import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const fmtCurrency = (n) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);

export const fmtNumber = (n) => new Intl.NumberFormat('en-US').format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const STATUS_LABELS = {
  new_lead: 'New Lead',
  research_needed: 'Research',
  initial_outreach: 'Initial Outreach',
  followup_1: 'Follow-Up #1',
  followup_2: 'Follow-Up #2',
  meeting_scheduled: 'Meeting Scheduled',
  proposal_sent: 'Proposal Sent',
  negotiation: 'Negotiation',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
  active: 'Active',
  nurturing: 'Nurturing',
  future_opportunity: 'Future Opportunity',
  inactive: 'Inactive',
};

export const PIPELINE_STAGES = [
  'new_lead',
  'research_needed',
  'initial_outreach',
  'meeting_scheduled',
  'proposal_sent',
  'negotiation',
  'closed_won',
  'closed_lost',
  'future_opportunity',
];

export const STATUS_COLORS = {
  new_lead: 'bg-slate-100 text-slate-700',
  research_needed: 'bg-blue-100 text-blue-700',
  initial_outreach: 'bg-indigo-100 text-indigo-700',
  followup_1: 'bg-purple-100 text-purple-700',
  followup_2: 'bg-purple-100 text-purple-700',
  meeting_scheduled: 'bg-amber-100 text-amber-700',
  proposal_sent: 'bg-orange-100 text-orange-700',
  negotiation: 'bg-pink-100 text-pink-700',
  closed_won: 'bg-emerald-100 text-emerald-700',
  closed_lost: 'bg-rose-100 text-rose-700',
  active: 'bg-green-100 text-green-700',
  nurturing: 'bg-teal-100 text-teal-700',
  future_opportunity: 'bg-cyan-100 text-cyan-700',
  inactive: 'bg-slate-100 text-slate-500',
};

export const ROLE_LABELS = {
  leadership: 'Leadership',
  director: 'Director',
  team_member: 'Team Member',
  contractor: 'Contractor',
  intern: 'Intern',
  viewer: 'Read-Only Viewer',
};

export const ROLE_OPTIONS = [
  { value: 'leadership', label: 'Leadership' },
  { value: 'director', label: 'Director' },
  { value: 'team_member', label: 'Team Member' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'intern', label: 'Intern' },
  { value: 'viewer', label: 'Read-Only Viewer' },
];

export const PARTNERSHIP_TYPES = [
  { value: 'media_partnership', label: 'Media Partnership' },
  { value: 'strategic_partnership', label: 'Strategic Partnership' },
  { value: 'sponsorship', label: 'Sponsorship' },
  { value: 'marketplace_partner', label: 'Marketplace Partner' },
  { value: 'workforce_partner', label: 'Workforce Partner' },
  { value: 'gala_partner', label: 'Gala Partner' },
  { value: 'cec', label: 'CEC (Community Engagement Council)' },
  { value: 'other', label: 'Other' },
];

export const CONTACT_TYPES = [
  'Member', 'Community Subscriber', 'Sponsor', 'Partner', 'Prospect', 'Volunteer',
  'Education Student', 'Education Provider', 'Apprentice', 'Workforce Participant',
  'Event Registrant', 'Donor', 'Media', 'Government', 'Employer',
];
export const PARTNERSHIP_TYPE_LABELS = PARTNERSHIP_TYPES.reduce((a, p) => ({ ...a, [p.value]: p.label }), {});

export const CLOSURE_TYPES = [
  { value: 'media_partnership_closed', label: 'Media Partnership Closed' },
  { value: 'strategic_partnership_closed', label: 'Strategic Partnership Closed' },
  { value: 'sponsorship_closed', label: 'Sponsorship Closed' },
  { value: 'marketplace_partner_closed', label: 'Marketplace Partner Closed' },
  { value: 'workforce_partner_closed', label: 'Workforce Partner Closed' },
  { value: 'gala_partner_closed', label: 'Gala Partner Closed' },
  { value: 'cec_closed', label: 'CEC Closed' },
  { value: 'donation_closed', label: 'Donation Closed' },
  { value: 'not_closed', label: 'Not Closed' },
  { value: 'future_opportunity', label: 'Future Opportunity' },
];

export const CLOSURE_TYPE_LABELS = CLOSURE_TYPES.reduce((a, c) => ({ ...a, [c.value]: c.label }), {});

export const TIERS_BY_TYPE = {
  media_partnership: [
    'Partner Spotlight Feature',
    'Featured Partner Spotlight Plus',
    'Industry Spotlight Package',
    'Leadership Impact Package',
    'Industry Influencer Package',
    'Presenting Partner Media Package',
    'Custom Media Package',
  ],
  strategic_partnership: [
    'Affiliate Partner',
    'Rising Partner',
    'Prime Partner',
    'Workforce Development Partner',
    'Leadership Impact Partner',
    'Innovation & Industry Partner',
    'Legacy Workforce Partner',
    'Custom Strategic Partner',
  ],
  sponsorship: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Custom'],
  marketplace_partner: ['Standard', 'Premium', 'Featured', 'Custom'],
  workforce_partner: ['Workforce Development Partner', 'Legacy Workforce Partner', 'Custom'],
  gala_partner: ['Table', 'Silver Gala', 'Gold Gala', 'Title Sponsor', 'Custom'],
  other: ['Custom'],
};

export const RESOURCE_CATEGORIES = [
  'Partnership Sales Resources',
  'Media Partnership Resources',
  'Strategic Partnership Resources',
  'Sponsorship Resources',
  'Marketplace Resources',
  'Gala Partnership Resources',
  'Workforce Partnership Resources',
  'Email Templates',
  'Phone Scripts',
  'Contracts & Agreements',
  'Brand Assets',
  'Training Materials',
  'SOPs',
  'Reports',
];
